module.exports = __webpack_public_path__ + "img/payment-gateways-en.f4421bd1.svg";